export const MAX_GRADE_LABEL = 40;
